import { Box, DisplayIcon, Flex, Heading, Text } from 'ui'
import styled from 'styled-components'
import { CalculatorIcon } from 'lucide-react'
import { usePaymentSummary } from './usePaymentSummary'
import { calculateBillRateCharge } from 'lib/payment'
import { formatCurrency } from 'lib/string'

const LineItem = styled(Flex).attrs({
  px: 3,
  fontSize: 1,
})``

export function BillRateChargeSummary({ billRate }: { billRate: number }) {
  const paymentData = usePaymentSummary()
  const baseCharge = calculateBillRateCharge({
    billRate,
    numWorkers: paymentData.numWorkers,
    hours: paymentData.hours,
  })

  if (!baseCharge) {
    return null
  }

  const total = baseCharge + paymentData.totalBonus

  return (
    <Box
      p={3}
      backgroundColor={'neutrals.50'}
      borderRadius={'large'}
      color={'neutrals.400'}
    >
      <Box display={'inline-flex'} alignItems={'center'}>
        <DisplayIcon>
          <CalculatorIcon size={16} />
        </DisplayIcon>
        <Heading level={4} my={0} ml={2}>
          Charge Per Shift
        </Heading>
      </Box>
      <Box mt={3}>
        <Text fontWeight={2} mb={2}>
          Base Charges
        </Text>
        <LineItem>
          <Box flex={1}>Workers</Box>
          {paymentData.numWorkers}
        </LineItem>
        {paymentData.hoursPerShift ? (
          <LineItem>
            <Box flex={1}>Hours Per Shift</Box>
            {paymentData.hoursPerShift}
          </LineItem>
        ) : null}
        <LineItem>
          <Box flex={1}>Bill Rate Per Hour</Box>${billRate.toFixed(2)}
        </LineItem>
        <hr />
        <LineItem>
          <Box flex={1} />
          <Text fontWeight={2}>${baseCharge.toFixed(2)}</Text>
        </LineItem>
        {paymentData.bonusPerWorker ? (
          <>
            <Text fontWeight={2} mb={2} mt={3}>
              Bonus
            </Text>
            <LineItem>
              <Box flex={1}>
                Bonus per{' '}
                {paymentData.numShiftLeads > 0 ? 'Worker/Shift Lead' : 'Worker'}
              </Box>
              {formatCurrency(paymentData.bonusPerWorker)}&nbsp;x&nbsp;
              {paymentData.numWorkers + paymentData.numShiftLeads}
            </LineItem>
            <LineItem>
              <Box flex={1}>
                WorkWhile Fee ({paymentData.bonusWWFeePercent}%)
              </Box>
              ${paymentData.bonusWWFee.toFixed(2)}
            </LineItem>
            <hr />
            <LineItem>
              <Box flex={1} />
              <Text fontWeight={2}>${paymentData.totalBonus.toFixed(2)}</Text>
            </LineItem>
          </>
        ) : null}
        <Text fontWeight={2} mb={2} mt={3}>
          Total
        </Text>
        <LineItem>
          <Box flex={1}>Total Charge Per Shift</Box>
          <Text fontWeight={1} fontSize={3} color={'info'}>
            ${total.toFixed(2)}
          </Text>
        </LineItem>
      </Box>
    </Box>
  )
}
